var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PsdDownBtn"},[_c('a-button',{staticStyle:{"margin":"10px"},on:{"click":_vm.download}},[_c('a-icon',{attrs:{"type":"vertical-align-bottom"}}),_vm._v("封面psd源文件")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }